import { Component, OnInit } from '@angular/core';
import { WizardType, RegistrationStepQuery, RegistrationStepService, LoggingService, AuthService } from '@fgb/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'fgbcl-registration-entry-page',
  templateUrl: './registration-entry-page.component.html',
  styleUrls: ['./registration-entry-page.component.scss'],
})
export class RegistrationEntryPageComponent implements OnInit {
  constructor(
    protected registrationStepService: RegistrationStepService,
    protected registrationStepQuery: RegistrationStepQuery,
    protected router: Router,
    protected route: ActivatedRoute,
    protected logService: LoggingService,
    protected authService: AuthService
  ) {}

  ngOnInit() {
    const wizardType: WizardType | undefined = this.route.snapshot.data.wizardType;
    if (wizardType === undefined) {
      this.logService.error('No wizard type could be found for this route.');
      return;
    }

    const clearCache: boolean | undefined = this.route.snapshot.data.clearCache;
    if (clearCache === undefined) {
      this.logService.error('No wizard data of clearCache found, defaulting to false');
    } else if (clearCache) {
      // need to clear the cache here
      this.authService.logout().toPromise();
    }
    
    this.registrationStepService
      .startRegistrationProcess(wizardType, this.route.snapshot.queryParams)
      .toPromise();
  }
}
